<template>
  <section class="article-recommend">
     <div class="nextclick clr">
      <div class="nextclick-sub" id="ngWidget" data-key=""></div>
     </div>
  </section>
</template>

<script setup>
import {computed, onMounted} from "vue";

const catId = computed(() => props.context?.routing_data?.[0] ?? null)

const props = defineProps({
  context: {
    type: Object,
    default: () => ({})
  },
})

let start = 1;
function getRecommendCode(type){
 let code = {
  45479716: '5910-E519-933B-3185-1dyydn', // test for development
  191868: 'EAE1-4C0E-EADC-ED60-1dyykQ', // biznes
  191869: '8B67-57F1-10DF-5DE8-1dyymD', // kultura
  191879: '0933-7D2A-ADC5-1B4B-1dyyvo', // magazyn
  191875: 'C6D8-AE02-2ACA-55B2-1dyyuA', // opinie
  191866: 'B4E5-7D1B-B947-8757-1dyyab', // polska
  191872: 'C684-6969-950F-DD94-1dyyrx', // rozmaitosci
  191871: '6AE7-FAD0-0C13-D3F6-1dyypl', // spoleczenstwo
  191867: '9728-AE51-1B36-4432-1dyyd8', // swiat
  191870: '5B35-983C-C4F3-5CA0-1dyyo1', // technologie
 };
 return code[type];
}

const oneKey = getRecommendCode(catId.value);

onMounted(() => {
 const anchorId = document.getElementById("ngWidget");
 anchorId.setAttribute('data-key', oneKey);
 window.recomend.setContent(oneKey, start);
})
</script>

<style lang="scss">
@import '@/assets/scss/components/article/article-recommend.scss';
</style>
